import "./branding";

const whitelabel = xsuite.whitelabel;

whitelabel.apply_login_placeholder = function () {
	const login_email = document.getElementById("login_email");
	if (login_email) login_email.placeholder = "Employee id";

	const login_label = document.querySelector("label[for='login_email']");
	if (login_label) login_label.textContent = "Employee id or Username";
};

$(() => {
	whitelabel.apply_login_placeholder();

	if (!whitelabel.is_enabled()) return;
	document.documentElement.classList.add("xsuite-whitelabel");
	whitelabel.apply_favicon();
	whitelabel.observe_dom();
});
